/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_No_IngredientsInputs */

const en_recipe_no_ingredients = /** @type {(inputs: Recipe_No_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No ingredients yet.`)
};

const de_recipe_no_ingredients = /** @type {(inputs: Recipe_No_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Zutaten.`)
};

/**
* | output |
* | --- |
* | "No ingredients yet." |
*
* @param {Recipe_No_IngredientsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_no_ingredients = /** @type {((inputs?: Recipe_No_IngredientsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_No_IngredientsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_no_ingredients(inputs)
	return en_recipe_no_ingredients(inputs)
});